import { ExtraArgs, GetState } from '../types'
import { Application, ApplicationId, ARMApplication as ARM } from './models'
import ApplicationService from '../services/core/ApplicationService'
import { isHybrid, isRTF } from '../components/BuiltInDashboard/common/hybrid'

const CLOUDHUB = 'CLOUDHUB'
const RTF = 'MC'

export const getApps = (organization: string, environment: string, gs: GetState, {api}: ExtraArgs, withMetrics?: boolean): Promise<Application[]> => {
  const envId = environment ? environment : ''
  const appService = new ApplicationService(organization, api.arm(gs))
  const armApps = appService.getApplications(envId)

  if (withMetrics) {
    const apps = api.ui(gs).fetchApplication(envId)
    const appsPromises: [Promise<ApplicationId[]>, Promise<{ data: ARM[] }>] = [apps, armApps]
    return Promise.all(appsPromises).then((results: any[]) => {
      let apps: Application[] = results[0]
      let armApps: { data: ARM[] } = results[1]
      return armApps.data.map(app => {
        return transformToApp(app)
      }).filter(app => apps.filter(a => (isRTF(app.targetType) && a.id === app.name) || (!isRTF(app.targetType) && a.id === app.id)).length > 0)
    }).catch(reason => {
      return Promise.reject(new Error(reason))
    })
  } else {
    return armApps.then((response: { data: ARM[] }) => {
      return response.data.map(app => {
        return transformToApp(app)
      })
    }).catch(reason => {
      return Promise.reject(new Error(reason))
    })
  }
}

export const transformToApp = (arm: ARM): Application => {
  return {
    id: arm.target.type === CLOUDHUB ? getDefault(arm.details.domain) : arm.target.type === RTF ? arm.id : arm.artifact.name,
    hybridId: isHybrid(arm.target.type) ? arm.id.toString() : undefined,
    name: arm.target.type === CLOUDHUB ? getDefault(arm.id) : arm.artifact.name,
    status: arm.lastReportedStatus,
    targetType: arm.target.type === CLOUDHUB ? 'app' : arm.target.type.toLowerCase(),
    targetSubtype: arm.target.subtype,
    targetId: arm.target.id,
    serverName: arm.target.name
  }
}

const getDefault = (value: any) => (value ? value : '')
